exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".location-title[data-v-2a4e204a]{color:var(--text-muted);font-weight:400}.location-tabs[data-v-2a4e204a] .el-tabs__header{margin-bottom:24px}.location-loading[data-v-2a4e204a]{height:240px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a4e204a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/locations/Locations.vue
// module id = 599
// module chunks = 0